import { UrlConstants } from "../url.constants";
export class ApiGautrainConstants {
    static URL = UrlConstants.API_V2 + "Gautrain";
    static FUNCTION_SET_ZONES = "SetTownPlanningZones";
    static FUNCTION_SET_APPLICATION_TYPES = "SetGautrainApplicationTypes";
    static FUNCTION_GET_DISTINCT_APPLICATION_TYPES = "GetDistinctApplicationTypes";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetGautrainApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetProperties";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateGautrainInvoiceReport";
    static FUNCTION_GET_APPLICATION_TYPES = "GetGtApplicationTypes";
    static FUNCTION_GET_MY_AFLA_PORTAL_GAUTAIN_APPLICATIONS = "GetMyAFLAPortalGautrainApplications";
    static FUNCTION_GET_ALL_AFLA_PORTAL_GAUTAIN_APPLICATIONS = "GetAllAFLAPortalGautrainApplications";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalGautrainApplication";
    static FUNCTION_CREATE_RESUBMITTED_APPLICATION = "CreateResubmittedPortalGautrainApplication";
}
